import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode'; 

const UserContext = createContext(null);


export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [orgId, setOrgId] = useState(null);


  const setUserFromToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      setUserId(decoded.id);
      setOrgId(decoded.org_id)
    } catch (error) {
      console.error('Failed to decode token:', error);
    }
  };

  return (
    <UserContext.Provider value={{ userId, orgId, setUserFromToken }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for consuming context
export const useUser = () => {
  return useContext(UserContext);
};
